import React from 'react'
import MtInput from './Childs/MtInput'
import MultiSelect from 'react-multiple-select-dropdown-lite'
import { addFieldMap, delFieldMap, handleCustomValue, handleFieldMapping } from './IntegrationHelpers/IntegrationHelpers'

export default function ZohoInventoryFieldMap({ i, type, field, wcInventoryConf, setWcInventoryConf, wcCheckoutFieldOptions }) {
  const isNotRequired = field.zohoFormField === '' || wcInventoryConf.default.allFields[type].required?.indexOf(field.zohoFormField) === -1

  const getZohoFields = () => wcInventoryConf.default?.allFields?.[type]?.fields && Object.values(wcInventoryConf.default.allFields[type].fields).filter(fld => isNotRequired ? fld?.required !== true : fld?.required).map(fld => {
    return ({ label: fld.displayLabel, value: fld.apiName })
  })

  return (
    <div
      className={`flx flx-around mt-2 ${isNotRequired && 'mr-1'}`}
    >
      <MultiSelect
        defaultValue={field.formField}
        onChange={val => handleFieldMapping(val, 'formField', i, type, wcInventoryConf, setWcInventoryConf)}
        className="btcd-paper-drpdwn w-9 mr-2"
        options={wcCheckoutFieldOptions()}
        singleSelect
      />
      {field.formField === 'custom' && <MtInput onChange={ev => handleCustomValue(ev, i, type, wcInventoryConf, setWcInventoryConf)} label="Custom Value" className="mr-2" type="text" value={field.customValue} placeholder="Custom Value" />}

      <MultiSelect
        className="btcd-paper-drpdwn w-9"
        defaultValue={field.zohoFormField}
        onChange={val => handleFieldMapping(val, 'zohoFormField', i, type, wcInventoryConf, setWcInventoryConf)}
        options={getZohoFields()}
        disabled={!isNotRequired}
        singleSelect
        customValue
      />
      <button
        onClick={() => addFieldMap(i, type, wcInventoryConf, setWcInventoryConf)}
        className={`icn-btn sh-sm ml-2 ${!isNotRequired && 'mr-8'}`}
        type="button"
      >
        +
      </button>
      {
        isNotRequired && (
          <button onClick={() => delFieldMap(i, type, wcInventoryConf, setWcInventoryConf)} className="icn-btn sh-sm ml-1" type="button" aria-label="btn">
            x
          </button>
        )
      }
    </div>
  )
}
